/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $body = $('body, html')
	var $hud = $('.hud')
	var $linkPosition
	var $navList = $('.nav-list')
	var $preload = $('.preload')
	var $nav = $('nav')
	var $window = $(window)
	var tab = 0
	var windowScroll = 0

	$hud.hide()

	$window.on('scroll', function () {
		windowScroll = $(window).scrollTop()

		if (windowScroll < window.innerHeight) {
			if ($hud.length) $hud.hide()
		} else {
			if ($hud.length) $hud.show()
		}
	})

	$(window).load(function () {
		$preload.fadeOut()
		// adjustBodyHeight()
	})

	// if (getQS() !== undefined) tab = getQS()
	// init($('[data-id="' + tab + '"]').data('url'))

	// $('[data-id="' + tab + '"]')
	// 	.parent()
	// 	.addClass('active')

	// $navList.on('click', 'li > a', function () {
	// 	tab = $(this).data('id')
	// 	init($('[data-id="' + tab + '"]').data('url'))
	// 	$(this).parent().addClass('active').siblings().removeClass('active')

	// 	if (tab !== 0) changeURL('?s=' + tab)
	// 	else changeURL('')
	// })
	smoothScroll('a[href^="#"]')
	smoothScroll('#gototop')
	initAnimate()
	// initProcessSwitch()
	// initDetectDevice()
	initNav()
	initCarousel()
	initLazyLoad()
})

$(window).on('resize', function () {
	// adjustBodyHeight()
})

function getQS() {
	var url = location.href

	if (url.indexOf('?') != -1) {
		var s = ''
		var ary = url.split('?')[1].split('&')
		for (i = 0; i <= ary.length - 1; i++) {
			if (ary[i].split('=')[0] == 's') {
				s = ary[i].split('=')[1]
			}
		}
	}

	return s
}

function changeURL(url) {
	window.history.pushState({}, 0, '//' + window.location.host + window.location.pathname + url)
}

function init(url) {
	var $preload = $('.preload')

	$.ajax({
		url: url,
		cache: false,
		beforeSend: function () {
			$preload.show()
		},
		complete: function () {
			$preload.hide()
		},
	}).done(function (html) {
		var tab = url.split('.')[0]
		var menuData = {}
		var parsedHTML = $.parseHTML(html)
		console.log('parsedHTML', parsedHTML)
		var $replacedNav = parsedHTML[1].innerHTML
		var $replacedBanner = parsedHTML[3].innerHTML
		var $replacedContent = parsedHTML[5].innerHTML
		$('#navContent').html($replacedNav)
		$('#bannerContent').removeClass('milano gr').addClass(tab).html($replacedBanner)
		$('#content').html($replacedContent)
		$('#content .customers').removeClass('milano gr').addClass(tab)

		document.title = tab == 'gr' ? '米蘭絕色蜜粉餅2021 「知的幸福」 GR' : '米蘭絕色蜜粉餅2021 「知的幸福」'
		document.title = document.title + ' - Kanebo'

		$('.menuChanger').find('a span.series').text(menuData.title)

		$('body, html').scrollTop(0)
		navLinkClick('#navContent a')
		smoothScroll('#navContent a')

		initAnimate()
		initLazyLoadImage()
	})

	// adjustBodyHeight()
}

function navChange() {
	$('#navmenu').on('change', function () {
		if ($('#navmenu').is(':checked')) {
			$('body').css('overflow-y', 'hidden')
		} else {
			$('body').css('overflow-y', 'scroll')
		}
	})
}

function navLinkClick(target) {
	$(target).on('click', function () {
		if ($(this).attr('role') == 'dropdown') {
			$(this).toggleClass('list-open')
			$(this).siblings('ul').toggleClass('is-hidden')
		} else {
			$('.nav-icon').click()
		}
	})
}

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var $target = $($(this).attr('href'))
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
		})
	})
}

function adjustBodyHeight() {
	var space = $('nav').height()
	$('body').css('margin-top', space - 1)
}

function initAnimate() {
	$(`.product-title,
		.product-subtitle,
		.product-slogan,
		.product-text-title,
		.product-text-list,
		.product-text-cta`).each(function () {
		$(this).attr('data-aos', 'fade-up')
	})

	AOS.init({
		duration: 1000,
		// once: true,
	})
}

function initSvg() {
	$('.svg').each(function () {
		var $img = $(this)
		var imgID = $img.attr('id')
		var imgClass = $img.attr('class')
		var imgURL = $img.attr('src')
		// console.log($img)

		$.get(
			imgURL,
			function (data) {
				// console.log({
				// 	data,
				// })
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg')

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID)
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg')
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a')

				// Replace image with new SVG
				$img.replaceWith($svg)
			},
			'xml',
		)
	})
}

function initProcessSwitch() {
	let timer
	let speed = 2000
	let timerIsPause = false
	let currentTarget = 0
	let $switch = $('.process-switch')
	let $items = $switch.nextAll()

	$switch.on({
		mouseenter: function () {
			timerIsPause = true
		},
		mouseleave: function () {
			timerIsPause = false
		},
	})

	$items.on({
		mouseenter: function () {
			timerIsPause = true
		},
		mouseleave: function () {
			timerIsPause = false
		},
	})

	$items.each(function () {
		const $item = $(this)
		const index = $item.index() - 1

		$item.on('click', function () {
			$switch.find('.process-switch-button').eq(index).click()
		})
	})

	$switch.find('.process-switch-button').each(function () {
		const $button = $(this)
		const index = $button.index()

		$button.on('click', function () {
			$switch.find('.process-switch-button').removeClass('active')
			$button.addClass('active')

			$items.each(function () {
				$(this).removeClass('active')
			})

			$items.eq(index).addClass('active')
		})
	})

	timer = setInterval(function () {
		if (!timerIsPause) {
			currentTarget += 1

			if (currentTarget >= $items.length) currentTarget = 0
			$switch.find('.process-switch-button').eq(currentTarget).click()
		}
	}, speed)
}

function initDetectDevice() {
	var classNames = []
	if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios')
	if (navigator.userAgent.match(/android/i)) classNames.push('device-android')
	if (navigator.userAgent.match(/Firefox/i)) classNames.push('device-firefox')
	if (navigator.userAgent.match(/Edg/i)) classNames.push('device-edge')
	if (navigator.userAgent.match(/Chrome/i)) classNames.push('device-chrome')

	var html = document.getElementsByTagName('html')[0]

	if (classNames.length) classNames.push('on-device')
	if (html.classList) html.classList.add.apply(html.classList, classNames)
}

function initNav() {
	$('.navbar a[href^="#"]:not(".dropdown-toggle")').on('click', function () {
		$('.navbar-toggler').click()
	})

	const collapse = document.querySelector('.navbar-collapse')
	const options = { attributes: true }

	function callback(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				let showExist = $(mutation.target).hasClass('show')

				if (showExist) {
					$('body').addClass('nav--open')
				} else {
					$('body').removeClass('nav--open')
				}
			}
		})
	}

	const observer = new MutationObserver(callback)
	observer.observe(collapse, options)
}

function initCarousel() {
	$('.owl-carousel').each(function () {
		const _this = $(this)
		const { colorArrow = 'white', colorSwitcher, ...options } = _this.data('options')

		// console.log('options', options)

		_this.owlCarousel({
			...options,
			// onInitialized: startProgressBar,
			// onTranslate: resetProgressBar,
			// onTranslated: startProgressBar,
			navText: [
				`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.6px" height="15.5px" viewBox="0 0 40.6 15.5" style="overflow:visible;enable-background:new 0 0 40.6 15.5;" xml:space="preserve"><polyline class="color" style="fill:none;stroke-miterlimit:10;" points="0.3,15.1 20.3,0.6 40.3,15.1" stroke="${colorArrow}"></polyline></svg>`,
				`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.6px" height="15.5px" viewBox="0 0 40.6 15.5" style="overflow:visible;enable-background:new 0 0 40.6 15.5;" xml:space="preserve"><polyline class="color" style="fill:none;stroke-miterlimit:10;" points="0.3,15.1 20.3,0.6 40.3,15.1" stroke="${colorArrow}"></polyline></svg>`,
			],
		})

		_this.on({
			'changed.owl.carousel': (event) => {
				const _items = _this.find('.owl-item:not(.cloned)')
				const _activeItem = _items.eq(event.page.index)

				_items.find('.aos-init').addClass('invisible').removeClass('aos-animate')

				_activeItem.find('.aos-init').removeClass('invisible').addClass('aos-animate')
			},
		})

		if (colorSwitcher) {
			// const _switcher = _this.parentsUntil('.product').find(colorSwitcher)
			const _item = $(colorSwitcher).children()

			// console.log(_item)

			_item
				.addClass('clickable')
				// .attr('style', 'cursor: pointer;')
				.on('click', function (event) {
					let index = _item.index(this)
					let _body = $('body, html')
					let pos = _this.parentsUntil('.product').offset().top - $('.navbar').height()
					let _lazyImg = _this.find('img.lazy')
					// console.log('index', index)
					_this.trigger('to.owl.carousel', index)
					_this.trigger('stop.owl.autoplay')

					_body.animate({
						scrollTop: pos,
					})

					_lazyImg.each(function () {
						let src = $(this).attr('src')
						if (src) return
						$(this).attr('src', $(this).data('src'))
					})
				})
		}
	})
}

function initLazyLoad() {
	let utils = new Utils()

	function lazyLoad() {
		$('.lazy').each(function () {
				if (utils.isElementInView(this)) {
						var $element = $(this);
						var src = $element.data('src');
						var type = $element.data('type');

						if (type === 'iframe') {
							var iframe = document.createElement('iframe');
                            
							// Set attributes from data attributes
							iframe.src = src;
							iframe.title = $element.attr('title');
							iframe.frameBorder = $element.attr('frameborder') || 0;
							iframe.allow = $element.attr('allow') || '';
							iframe.allowFullscreen = $element.attr('allowfullscreen');
							iframe.playsinline = $element.attr('playsinline');

							// Append the iframe to the element
							$element.replaceWith(iframe);
						} else {
								$element.attr('src', src);
						}

						$element.removeClass('lazy');
				}
		});
	}

	$(window).on('scroll', function () {
		lazyLoad();
	});
	lazyLoad();
}

// function startProgressBar() {
//   // apply keyframe animation
//   $(".kv-carousel-progress span").css({
//     width: "100%",
//     transition: "width 6000ms"
//   });
// }

// function resetProgressBar() {
//   $(".kv-carousel-progress span").css({
//     width: 0,
//     transition: "width 0s"
//   });
// }

function Utils() {}

Utils.prototype = {
	constructor: Utils,
	isElementInView: function (element, fullyInView) {
		var pageTop = $(window).scrollTop()
		var pageBottom = pageTop + $(window).height()
		var elementTop = $(element).offset().top
		var elementBottom = elementTop + $(element).height()

		if (fullyInView === true) {
			return pageTop < elementTop && pageBottom > elementBottom
		} else {
			return elementTop <= pageBottom && elementBottom >= pageTop
		}
	},
	smoothScroll: function () {
		$('a[href^="#"]').on('click', function (e) {
			var $target = $(e.currentTarget.hash)

			$('html,body').animate(
				{
					scrollTop: $target.offset().top,
				},
				700,
			)

			e.preventDefault()
		})
	},
	detectViewport: function () {
		return { height: window.innerHeight, width: window.innerWidth }
	},
}
